// :0:每日, 1:平日, 2:假日, 3:假日含國定例假日
export enum E_ParkingFeeDayType {
  Daily = 'Daily',
  Weekday = 'Weekday',
  Holiday = 'Holiday',
  HolidayWithNationalHoliday = 'HolidayWithNationalHoliday',
}

export const ParkingFeeDayTypeStr = {
  [E_ParkingFeeDayType.Daily]: '每日',
  [E_ParkingFeeDayType.Weekday]: '平日',
  [E_ParkingFeeDayType.Holiday]: '假日',
  [E_ParkingFeeDayType.HolidayWithNationalHoliday]: '假日含國定例假日',
}

export const ParkingFeeDayType = {
  [E_ParkingFeeDayType.Daily]: 0,
  [E_ParkingFeeDayType.Weekday]: 1,
  [E_ParkingFeeDayType.Holiday]: 2,
  [E_ParkingFeeDayType.HolidayWithNationalHoliday]: 3,
}

export type BasicFeeType = {
  dayMaximumFeeAmount: number
  feeStartAfter: number
  rate: number
  signInterval: number
}


export const OperationType = [
  { label: '公辦民營', value: 0 },
  { label: '公辦公營', value: 1 },
  { label: '私有民營', value: 2 },
]

export const LocationType = [
  { label: '高速公路', value: 0 },
  { label: '地標', value: 1 },
  { label: '地址', value: 2 },
]

export const FloorType = [
  { label: 'B3', value: 'B3' },
  { label: 'B2', value: 'B2' },
  { label: 'B1', value: 'B1' },
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
]

export const DayType = [
  { label: '每日', value: '1' },
  { label: '平日', value: '2' },
  { label: '假日', value: '3' },
]
